import ReactDOM from 'react-dom';
import { markTeacherViewingSelf } from '../common/markTeacherViewingSelf.js';
import { ProjectPageShareBar } from './ProjectPageShareBar.js';
import { markPhotoPendingScreening } from './markPhotoPendingScreening.js';
import { isUserTheTeacher } from '../utils/userUtils.js';
import { getProjectTwitterText } from '../sharebar/sharebarHelperFunctions.js';
import { registerUpdateClassroomPhotoOnUnderlyingPage } from '../teacherclassroomphoto/teacherClassroomPhotoUpdate.js';

function render(teacherSharebar) {
    const targetElement = document.getElementById('teacher-share-tools');
    $(targetElement).show();

    ReactDOM.render(
        <ProjectPageShareBar
            teacherSharebar={teacherSharebar}

            projectId={window.proposalId}
            pageName={window.pageName}
            facebookAppId={window.facebookAppId}
            baseURL={window.baseURL}

            getTafURL={window.getTafURL} // defined in general/sharebar.js
            getTafEmail={window.getTafEmail} // defined in general/sharebar.js

            getTrackingLink={window.getTrackingLink} // defined in queryParams.js
            getTwitterText={getProjectTwitterText} // defined in sharebar/sharebarHelperFunctions.js
            root={targetElement}
        />,
        targetElement,
    );
}

function handleResponse(data) {
    const teacherSharebar = data.publicData.sharebar;

    if (data.privateData && data.privateData.hasClassroomPhotoPendingScreening) {
        markPhotoPendingScreening();
    }
    // When the teacher uploads a new photo on this page, we should update the page to show the pending-screening
    // widget, not the actual new photo. This makes that happen - see teacherClassroomPhotoUpdate.js.
    registerUpdateClassroomPhotoOnUnderlyingPage(markPhotoPendingScreening);

    // The server can decide not to show a sharebar on this project
    // (if it's suspended, has never been submitted, etc.)
    if (!teacherSharebar.shouldShow) {
        return;
    }

    render(teacherSharebar);
}

export const main = () => {
    const shouldShow = isUserTheTeacher() || qsParam.showSharetools === 'true';
    if (shouldShow) {
        // This is kind of a hack in that this isn't related to the project page share bar.
        // I'm putting it here because it's also code that runs if and only
        // if the teacher's looking at their own page.
        markTeacherViewingSelf();

        $.ajax({
            url: secureBaseURL + 'teacher/extra_project_data.html?projectId=' + proposalId,
            method: 'GET',
            // We'd like to request JSON here, but that would trigger a CORS preflight request
            // that would be blocked in httpd. Plain text is one of a handful of content-types
            // that can be used in a CORS "simple request" (without a preflight).
            contentType: 'text/plain; charset=utf-8',
            xhrFields: {
                withCredentials: true,
            },
        }).done(function (json) {
            handleResponse(json);
        });
    }
};
